import React, { Component } from "react";
import { translations } from "../../containers/assets/translations";
import {
  ControlLabel,
  Row,
  Col,
  FormGroup,
  FormControl,
  Button,
} from "react-bootstrap";

export default class BGRSearchFilter extends Component {
  render() {
    const {
      searchFields,
      onSearch,
      onChange,
      onCreate,
      canCreate,
      lang = "EN",
    } = this.props;

    const t = translations[lang] || translations["EN"];

    return (
      <Col className="search-reservation-container" md={12}>
        <div className="search-fields-grid-bgr">
          {/* ... Passport Number ... */}
          <Col md={3} className="search-field-col">
            <FormGroup bsSize="large">
              <ControlLabel>{t["Passport Number"]}</ControlLabel>
              <FormControl
                type="text"
                name="passportNumber"
                value={searchFields.passportNumber}
                onChange={onChange}
                className="well"
              />
            </FormGroup>
          </Col>

          {/* ... Reservation ID ... */}
          <Col md={3} className="search-field-col">
            <FormGroup bsSize="large">
              <ControlLabel>{t["Reservation ID"]}</ControlLabel>
              <FormControl
                type="text"
                name="reservationId"
                value={searchFields.reservationId}
                onChange={onChange}
                className="well"
              />
            </FormGroup>
          </Col>

          {/* ... License Plate ... */}
          <Col md={3} className="search-field-col">
            <FormGroup bsSize="large">
              <ControlLabel>{t["License Plate"]}</ControlLabel>
              <FormControl
                type="text"
                name="licensePlate"
                value={searchFields.licensePlate}
                onChange={onChange}
                className="well"
              />
            </FormGroup>
          </Col>

          {/* ... Transport Company ... */}
          <Col md={3} className="search-field-col">
            <FormGroup bsSize="large">
              <ControlLabel>{t["Transport Company"]}</ControlLabel>
              <FormControl
                type="text"
                name="transportCompany"
                value={searchFields.transportCompany}
                onChange={onChange}
                className="well"
              />
            </FormGroup>
          </Col>

          {/* Row 2: Status */}
          <Col md={3} className="search-field-col">
            <FormGroup bsSize="large">
              <ControlLabel>{t["Status"]}</ControlLabel>
              <FormControl
                componentClass="select"
                name="reservationStatus"
                value={searchFields.reservationStatus || ""}
                onChange={onChange}
                className="well"
              >
                <option value="">{t["Select Status"]}</option>
                <option value="CREATED">Created</option>
                <option value="SUBMITTED">Submitted</option>
                <option value="CLOSED">Closed</option>
                <option value="REJECTED">Rejected</option>
              </FormControl>
            </FormGroup>
          </Col>

          {/* Travel Date & Time */}
          <Col md={3} className="search-field-col">
            <FormGroup bsSize="large">
              <ControlLabel>{t["Travel Date"]}</ControlLabel>
              <div style={{ display: "flex", gap: "5px" }}>
                <FormControl
                  type="date"
                  name="travelDate"
                  value={searchFields.travelDate}
                  onChange={onChange}
                  className="well"
                />
                <FormControl
                  type="time"
                  name="travelTime"
                  value={searchFields.travelTime}
                  onChange={onChange}
                  className="well"
                  style={{ width: "220px" }}
                />
              </div>
            </FormGroup>
          </Col>

          {/* Creation Date & Time */}
          <Col md={3} className="search-field-col">
            <FormGroup bsSize="large">
              <ControlLabel>{t["Creation Date"]}</ControlLabel>
              <div style={{ display: "flex", gap: "5px" }}>
                <FormControl
                  type="date"
                  name="creationDate"
                  value={searchFields.creationDate}
                  onChange={onChange}
                  className="well"
                />
                <FormControl
                  type="time"
                  name="creationTime"
                  value={searchFields.creationTime}
                  onChange={onChange}
                  className="well"
                  style={{ width: "220px" }}
                />
              </div>
            </FormGroup>
          </Col>

          {/* Search Button */}
          <Col md={3} className="search-field-col search-button-container">
            <Button bsStyle="primary" bsSize="large" onClick={onSearch} block>
              {t["Search BGR"]}
            </Button>
          </Col>
        </div>

        <hr className="col-md-12" />

        {canCreate && (
          <Row>
            <Col md={9} />
            <Col md={3}>
              <div className="create-bgr-action-container">
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  onClick={onCreate}
                  block
                >
                  {t["Create BGR"]}
                </Button>
              </div>
            </Col>
          </Row>
        )}
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/bgrComponents/BGRSearchFilter.js